import { render, staticRenderFns } from "./bindBank.vue?vue&type=template&id=d983eb90&scoped=true&"
import script from "./bindBank.vue?vue&type=script&lang=js&"
export * from "./bindBank.vue?vue&type=script&lang=js&"
import style0 from "./bindBank.vue?vue&type=style&index=0&id=d983eb90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d983eb90",
  null
  
)

export default component.exports